// Bootstrap
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ListGroup from 'react-bootstrap/ListGroup';
import Alert from 'react-bootstrap/Alert';

// React
import { useEffect, useState } from "react";
// Api 
import Api from "../api.js";
// Components
import WatchlistItem from "../components/WatchlistItem.js";
// Libs
import { TwitterShareButton } from 'react-twitter-embed';

const takeTags = (watchlist) => {
  const tags = watchlist.map((item) => item.tags).flat();
  return [...new Set(tags)];
}

const getCount = (watchlist, tag) => {
  return watchlist.filter((item) => item.tags.includes(tag)).length;
}

const Watchlist = () => {
  const [watchlist, setWatchlist] = useState([]);
  const [tags, setTags] = useState([]);
  const [filter, setFilter] = useState({
    tags: [],
    // search: "",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (watchlist.length === 0) {
      Api.getWatchlist().then((data) => {
        setWatchlist(data);
        setLoading(false);
        setTags(takeTags(data));
        console.log(data);
        console.log(takeTags(data));
      });
    }
  }, [])

  return (
    <>
      <Row className="justify-content-md-center">
        <Col>
          <Row className="justify-content-md-center text-center">
            <h2>Useful things worth checking out.</h2>
          </Row>
          <Row className="justify-content-md-center">
            <Col>  
              <div className="text-center" style={{
                borderRadius: "6px",
                margin: "10px",
              }}>
                <div style={{marginTop: "12px"}}>
                  <TwitterShareButton
                      url={'https://0xfire.com/things'}
                      options={{ text: 'Checkout this thing for ', via: '0xconstantin' }}
                    />
                </div>
                <p style={{color: "rgb(0 80 134)", fontSize: "12px", marginBottom: "8px"}}>suggest a thing</p>
              </div>
              <hr/>
            </Col>
          </Row>
          {watchlist && watchlist.map((item) => {
            if (filter.tags.length === 0 || filter.tags.some((tag) => item.tags.includes(tag))) {
              return (
                <WatchlistItem key={item.id} item={item}/>
              );
            }
          })}
        </Col>
        <Col xs="12" md="2" sm="12">
          <h4>Tags:</h4>
          <ListGroup>
            {tags && tags.map((tag) => 
            <ListGroup.Item key={tag} style={{cursor: "pointer", fontSize: "12px"}} variant={filter.tags.includes(tag) ? 'primary' : "light"}
              onClick={() => {
                if (filter.tags.includes(tag)) {
                  setFilter({
                    ...filter,
                    tags: filter.tags.filter((item) => item !== tag),
                  });
                } else {
                  setFilter({
                    ...filter,
                    tags: [...filter.tags, tag],
                  });
                }
              }}
            >
              {tag} ({getCount(watchlist, tag)})
            </ListGroup.Item>
          )}
          </ListGroup>
        </Col>
      </Row>
    </>
  );
};

export default Watchlist;
